import React, { useEffect } from "react";
import about from "../../../../assets/image/about/about-h.jpg";
import aboutus from "../../../../assets/image/category/aboutUs.webp"; 
import brakelogo from "../../../../assets/image/about/brakelogo.webp";
import suspensionLogo from "../../../../assets/image/about/Suspension & Steering.webp";
import maintenanceLogo from "../../../../assets/image/about/Auto-Maintenance.webp";
import logo1 from "../../../../assets/image/about/Total Vehicles Serviced.webp";
import logo2 from "../../../../assets/image/about/Transparency.png";
import logo3 from "../../../../assets/image/about/Years of Experience.webp";
import logo4 from "../../../../assets/image/about/Years of Service.webp";
import layer from "../../../../assets/image/about/Layer-1121.jpg";
import { Link } from "react-router-dom";
import Footer from "../homePage/components/footer/Footer";
import MyButton from "../utils/Button/MyButton";
const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* First Section: Header with Image and Text */}
      <div className="overflow-hidden w-full h-full ">
        <div className="flex w-[100%] lg:flex-row flex-col lg:px-[8%] md:px-[7%] mx-2 lg:mt-4 md:mt-4 sm:mt-2">
          <div
            className="lg:w-[53%] md:w-full w-[96%] mt-2 rounded-xl lg:h-[65vh] md:h-[35vh] h-[40vh] bg-cover mb-2 bg-center lg:object-contain object-cover "
            style={{ backgroundImage: `url(${aboutus})` }}
          ></div>
          <div className="text-center lg:mt-9 md:mt-3 sm:mt-4 lg:px-4 md:px-4 px-2 lg:w-[50%] ">
            <h1 className="text-black font-bold lg:text-5xl md:text-5xl text-3xl text-start mb-2">
               <span className="text-[#2772AD]">About </span>
            </h1>
            <p className="lg:mt-3 mt-2 lg:text-[1.3rem] md:text-[1.3rem] text-xl text-start ">
              Vancouver Auto Parts has been serving the Lower Mainland forging a
              solid reputation as the best choice for all your automotive repair
              needs. Located a stone’s throw from Central City in Surrey, we are
              well positioned to serve many of the surrounding communities’
              automotive repair needs
            </p>

            <Link to="/contact-us">
              <MyButton
                text="  Consult with Us "
                className="py-[11px] transform  transition-transform duration-500 hover:scale-110"
              />
            </Link>
          </div>
        </div>

        {/* Third Section: Cards */}
        <div className="bg-[#F1F4FF] py-4 mt-3">
          <h1 className="text-center text-blue-900 font-bold lg:text-5xl md:text-5xl text-[2rem] py-4">
            Complete Care for Your Vehicle
          </h1>
          <div className=" lg:w-10/12 md:w-[85%] w-[93%] mx-auto lg:my-8 md:my-6 sm:my-3 lg:px-2 px-0">
            <div className="grid  text-[#034C8C] md:grid-cols-3 gap-2 ">
              {/* Card 1: Brake Services */}
              <div className=" lg:p-4 p-3 sm:p-4  rounded-lg h-[300px] lg:border-0 border-1 border-blue-900">
                <div className="flex  mb-3">
                  <img
                    src={brakelogo}
                    alt="Brake Logo"
                    className="h-[50px] w-[50px] ;"
                  />
                </div>
                <h3 className="lg:text-2xl md:text-xl font-bold">
                  Brake Services
                </h3>
                <p className="mt-1">
                  From a basic service to full replacement, our mechanics have
                  years of experience working with the braking system of a wide
                  variety of makes and models.
                </p>
              </div>

              {/* Card 2: Suspension & Steering */}
              <div className="lg:p-4 p-3 sm:p-4  rounded-lg border-1 border-blue-900 h-[300px]">
                <div className="flex  mb-3">
                  <img
                    src={suspensionLogo}
                    alt="Suspension Logo"
                    className="h-[50px] w-[50px]"
                  />
                </div>
                <h3 className="lg:text-2xl md:text-xl font-bold">
                  Suspension & Steering
                </h3>
                <p className="mt-1">
                  Vancouver Auto Parts mechanics can quickly and efficiently
                  resolve issues with your suspension and steering getting your
                  vehicle back on track .
                </p>
              </div>

              {/* Card 3: Auto Maintenance */}
              <div className="  lg:p-4 p-3 sm:p-4   rounded-lg border-1 border-blue-900 h-[300px]">
                <div className="flex  mb-3">
                  <img
                    src={maintenanceLogo}
                    alt="Maintenance Logo"
                    className="h-[50px] w-[50px]"
                  />
                </div>
                <h3 className="lg:text-2xl md:text-xl font-bold ">
                  Auto Maintenance
                </h3>
                <p className="mt-1 ">
                  The cost of routine maintenance is minimal compared to the
                  repairs resulting from a poorly maintained vehicle.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Fourth Section: Why Choose Us */}
        <div className="w-full bg-[#034C8C] text-white pt-10 pb-10 lg:px-14 ">
          <div className="w-[90%] mx-auto flex flex-col md:flex-row justify-between items-center">
            {/* Left Side - Text */}
            <div className="w-full md:w-1/2 lg:pr-8 md:pr-8 ">
              <h3 className=" font-bold text-start lg:text-4xl md:text-3xl text-2xl  mb-3">
                WHY CHOOSE VANCOUVER AUTO PARTS?
              </h3>

              <p className="mt-4 text-lg ">
                Over the past 34 years, we have built and mentored a dedicated
                team of automotive professionals. All of our mechanics are
                highly skilled and knowledgeable, with the equipment and tools
                to get your vehicle back on the road. Combined, our technicians
                represent decades of training and experience that you don’t
                often find in other Lower Mainland shops.
              </p>
            </div>
            {/* Right Side - Stats */}
            <div className="w-full lg:w-1/2 grid grid-cols-2 gap-3 ">
              <div className="text-center border border-white-100 rounded-md flex items-center flex-col   ">
                <img
                  src={logo1}
                  alt="Total Vehicles Serviced Logo"
                  className="mx-auto h-[50px] w-[50px] my-1 mt-3"
                />
                <h3 className="text-3xl font-bold">100,000+</h3>
                <p className=" text-sm">Total Vehicles Serviced</p>
              </div>
              <div className="text-center border border-white-100 rounded-md flex items-center flex-col justify-center ">
                <img
                  src={logo2}
                  alt="Transparency Logo"
                  className="mx-auto h-[50px] w-[50px] my-1 mt-3"
                />
                <h3 className="text-3xl font-bold">100%</h3>
                <p className="text-sm">Transparency</p>
              </div>
              <div className="text-center border border-white-100 rounded-md flex items-center flex-col justify-center ">
                <img
                  src={logo3}
                  alt="Years of Experience Logo"
                  className="mx-auto h-[50px] w-[50px] my-1 mt-3"
                />
                <h3 className="text-3xl font-bold">100+</h3>
                <p className="text-sm">Years of Experience</p>
              </div>
              <div className="text-center border border-white-100 rounded-md flex items-center flex-col justify-center ">
                <img
                  src={logo4}
                  alt="Years of Service Logo"
                  className="mx-auto h-[50px] w-[50px] my-1 mt-3"
                />
                <h3 className="text-3xl font-bold">35+</h3>
                <p className="text-sm">Years of Service</p>
              </div>
            </div>
          </div>
        </div>

        {/* Fifth Section: */}
        <div
          className="w-full lg:h-[250px] h-[200px] bg-cover bg-center bg-[#3e82bdef] "
          // style={{ backgroundImage: `url(${layer})` }}
        >
          <div className="w-full flex justify-center flex-col items-center h-full ">
            <h1 className="text-white lg:text-[2.9rem] md:text-2xl text-2xl mb-4  font-bold  text-wrap text-center">
              Need help finding the right part ?
            </h1>

            <Link to="/contact-us">
              <MyButton
                text="Contact Us"
                className="transform mt-2  transition-transform duration-500 hover:scale-110"
              />
            </Link>
          </div>
        </div>

        {/* Content Section Below */}
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default About;
